module.exports = __webpack_public_path__ + "static/tat-36-4603067d8631b1aca8227595182a3ef2.jpg";